/* InviteUserModal — collects email + initial tier and hands them to the
   parent's onInvite callback. The backend (POST /api/manage/users/invite)
   creates a pending-user doc, sends an invite email via Azure Communication
   Services when COMMS_CONN_STRING + COMMS_SENDER_ADDRESS are provisioned,
   and always returns an invite URL so admins can copy/paste if delivery
   fails. Modal focus trap + Esc-close are provided by the Modal primitive. */
import React, { useState, useEffect } from "react";
import { P } from "../../shared/constants";
import Modal from "../components/Modal";
import { Info } from "../icons";
var E = React.createElement;

export default function InviteUserModal(props){
  var st = useState({ email:"", tier:"free" });
  var f = st[0], setF = st[1];
  useEffect(function(){ if(props.open) setF({ email:"", tier:"free" }); }, [props.open, setF]);

  function submit(){
    var email = (f.email||"").trim();
    if(!email){ props.showToast && props.showToast("Email is required","error"); return; }
    props.onInvite && props.onInvite({ email:email, tier:f.tier });
  }

  function inputStyle(){
    return {width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid "+P.bdr,
      fontSize:13,minHeight:40,background:P.card,color:P.slate};
  }
  function labelStyle(){
    return {display:"block",fontSize:11,fontWeight:700,color:P.slateM,marginBottom:6};
  }

  return E(Modal,{
    open:props.open, onClose:props.onClose,
    title:"Invite user", size:"sm",
    footer:[
      E("button",{key:"cancel",type:"button",onClick:props.onClose,
        style:{padding:"8px 14px",borderRadius:8,border:"1px solid "+P.bdr,
          background:P.card,fontSize:11,fontWeight:600,cursor:"pointer",minHeight:36}},"Cancel"),
      E("button",{key:"go",type:"button",onClick:submit,
        style:{padding:"8px 14px",borderRadius:8,border:"none",
          background:P.pri,color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",minHeight:36}},
        "Send invite")
    ]
  },
    E("div",{role:"note",style:{display:"flex",gap:10,padding:"10px 12px",borderRadius:8,
      background:P.priLt,border:"1px solid "+P.pri+"30",marginBottom:14,alignItems:"flex-start",color:P.priDk||P.pri}},
      E(Info,{size:16}),
      E("div",{style:{fontSize:11,lineHeight:1.5}},
        "Invites are delivered via Azure Communication Services from ",
        E("code",{style:{fontFamily:"IBM Plex Mono,monospace"}}, "donotreply@paris.pi-consulting.us"),
        ". The invite link is also copied to your clipboard so you can share it directly if email bounces.")),
    E("div",{style:{display:"grid",gap:14}},
      E("div",null,
        E("label",{htmlFor:"iu-email",style:labelStyle()}, "Email address"),
        E("input",{id:"iu-email",type:"email",value:f.email,
          onChange:function(e){setF(Object.assign({},f,{email:e.target.value}))},
          placeholder:"alice@example.gov", autoFocus:true, required:true,
          style:inputStyle()})),
      E("div",null,
        E("label",{htmlFor:"iu-tier",style:labelStyle()}, "Initial tier"),
        E("select",{id:"iu-tier",value:f.tier,
          onChange:function(e){setF(Object.assign({},f,{tier:e.target.value}))},
          style:inputStyle()},
          E("option",{value:"free"},"Free"),
          E("option",{value:"starter"},"Starter"),
          E("option",{value:"pro"},"Pro"),
          E("option",{value:"admin"},"Admin"))))
  );
}
